// extracted by mini-css-extract-plugin
export var box = "_4l-0";
export var check = "_4l-1";
export var checkboxButton = "_4l-6";
export var checkboxGroup = "_4l-5";
export var disabled = "_4l-7";
export var ghost = "_4l-9";
export var input = "_4l-2";
export var label = "_4l-4";
export var normal = "_4l-8";
export var uncheck = "_4l-3";